<template>
  <div class="automation">
    <div style="float: left">
      <el-input class="inline-input" v-model="keyword" placeholder="Search name, tags" :trigger-on-focus="false"
        style="width: auto" clear></el-input>
      <el-select v-model="showType" placeholder="Select Type">
        <el-option key="any" label="All" value="" />
        <el-option key="cron" label="CRON (automated)" value="cron" />
        <el-option key="manual" label="Campaign (manual)" value="manual" />
        <el-option key="event" label="Event based" value="event" />
        <el-option key="script" label="CRON Script" value="script" />
      </el-select>
    </div>
    <div style="text-align: right">
      <el-button @click="openAutomation(0)" type="primary">+ Add new Automation</el-button>
      <el-button @click="openJobs" type="default">Automation Jobs</el-button>
      <el-button @click="goto('logs')" type="default">Automation logs</el-button>
      <el-button @click="goto('mailgun_templates')" type="default">Email Templates</el-button>
      <el-button @click="goto('notice_templates')" type="default">Notice Templates</el-button>
    </div>
    <hr />
    <el-table :data="data
        .filter((itm) => {
          if (!keyword) {
            return itm;
          } else {
            if (
              itm.name.toLowerCase().includes(keyword.toLowerCase()) ||
              (itm.tags &&
                itm.tags.toLowerCase().includes(keyword.toLowerCase()))
            ) {
              return itm;
            }
          }
        })
        .filter((itm) => {
          if (
            showType &&
            showType == 'script' &&
            itm.content_type == 'script'
          ) {
            return itm;
          } else if (showType && itm.automation_type === showType) {
            return itm;
          } else if (!showType) {
            return itm;
          }
        })
      " style="width: 100%" :default-sort="{ prop: 'name', order: 'ascending' }" v-loading="loading">
      <el-table-column prop="id" label="Id" sortable width="70"></el-table-column>
      <el-table-column prop="status" label="Status" sortable width="90">
        <template slot-scope="scope">
          <el-popconfirm title="Are you sure you want to change status?" v-if="
            scope.row.automation_type == 'cron' ||
            scope.row.automation_type == 'event' ||
            scope.row.automation_type == 'cron_event'
          " @confirm="
              updateField(
                'status',
                scope.row.id,
                scope.row.status == 'OK' ? 0 : 1
              )
              ">
            <el-button slot="reference" size="mini" type="text"><i class="fas fa-circle"
                :style="{ color: scope.row.status == 'OK' ? 'green' : 'red' }"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="Name" sortable></el-table-column>
      <el-table-column prop="automation_type" label="Type" sortable>
        <template slot-scope="scope">
          <span>{{ scope.row.automation_type }}</span><br />
          <span>{{ scope.row.user_type }}</span><br />
        </template>
      </el-table-column>
      <el-table-column prop="content_type" width="80" label="Content Type"></el-table-column>
      <el-table-column prop="description" label="Description"></el-table-column>
      <el-table-column prop="when" label="When to check">
        <template slot-scope="scope">
          <div>
            <el-button v-if="
              scope.row.automation_type &&
              scope.row.automation_type === 'manual'
            " size="mini" type="success" @click="openAutomation(scope.row.id, true)">Manual
            </el-button>
            <span v-if="scope.row.automation_type != 'manual'">{{
              scope.row.when_to_launch
              }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Created" sortable class-name="smallFont">
        <template slot-scope="scope">
          <span :title="scope.row.created_at">{{ formatDate(scope.row.created_at) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="Updated" sortable class-name="smallFont">
        <template slot-scope="scope">
          <span :title="scope.row.updated_at">{{ formatDate(scope.row.updated_at) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Actions" width="220">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openAutomation(scope.row.id)"><i
              class="fas fa-pen-to-square"></i>
          </el-button>
          <el-dropdown size="mini">
            <el-button type="warning" size="mini" style="margin-left: 10px">
              <i class="far fa-chevron-down"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><el-button size="mini" type="text" @click="openStats(scope.row.id, scope.row.name, scope.row.content_type)">Stats
                </el-button></el-dropdown-item>
              <el-dropdown-item><el-button size="mini" type="text" @click="duplicateAutomation(scope.row.id)">Duplicate
                </el-button></el-dropdown-item>
              <el-dropdown-item><el-button size="mini" type="text" @click="automationSchedule(scope.row.id)">Upcoming
                  schedule</el-button></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button
            size="mini"
            type="warning"
            @click="duplicateAutomation(scope.row.id)"
            ><i class="fa-solid fa-copy"></i>
          </el-button> -->
          <el-popconfirm title="Are you sure you want to delete it?" @confirm="deleteAutomation(scope.row.id)"
            class="ml-10px">
            <el-button slot="reference" size="mini" type="danger"><i class="fas fa-trash"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import SingleAutomationModal from "@/modals/SingleAutomationModal.vue";
import AutomationsJobsModal from "@/modals/AutomationsJobsModal.vue";
import AutomationStatsModal from "@/modals/AutomationStatsModal.vue";
import AutomationScheduleModal from "@/modals/AutomationScheduleModal.vue";
// import TriggerAutomationModal from "@/modals/TriggerAutomationModal.vue";
import ApiService from "@/services/ApiService";
export default {
  name: "Automations",
  data() {
    return {
      keyword: "",
      showType: "",
      data: [],
      newAutomation: {},
      loading: false,
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = months[date.getMonth()];
      const day = date.getDate();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${month} ${day}, ${hours}:${minutes}`;
    },
    getAutomations() {
      ApiService.automationsApi.getAutomations().then((resp) => {
        this.data = resp.data;
      });
    },
    goto(path) {
      path = "/members/automations/" + path;
      this.$router.push(path);
    },
    openAutomation(id, isLaunchModal) {
      if (!isLaunchModal) isLaunchModal = false;

      this.$modal.show(
        SingleAutomationModal,
        {
          options: {
            // profilePicture: true,
          },
          id,
          isLaunchModal: isLaunchModal,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          width: 1150,
          height: "auto",
          adaptive: true,
          clickToClose: false,
        },
        {
          "before-close": this.getAutomations,
        }
      );
    },
    openJobs() {
      this.$modal.show(
        AutomationsJobsModal,
        {
          options: {
            // profilePicture: true,
          },
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          width: "95%",
          height: "auto",
          adaptive: true,
          clickToClose: true,
        },
        {
          // "before-close": this.getAutomations,
        }
      );
    },
    deleteAutomation(id) {
      ApiService.automationsApi.deleteItem("automation", id).then(() => {
        this.$notify.info({
          title: "Saved",
          message: "Deleted!",
        });
        this.getAutomations();
      });
    },
    duplicateAutomation(id) {
      ApiService.automationsApi.duplicateItem("automation", id).then(() => {
        this.$notify.info({
          title: "Duplicated!",
          message: "Done",
        });
        this.getAutomations();
      });
    },
    automationSchedule(id) {
      this.$modal.show(
        AutomationScheduleModal,
        {
          id: id,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          width: 1000,
          height: "auto",
          adaptive: true,
          clickToClose: true,
        }
      );
    },
    openStats(id, name, contentType) {
      this.$modal.show(
        AutomationStatsModal,
        {
          id: id,
          name: name,
          contentType,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          width: 1000,
          height: "auto",
          adaptive: true,
          clickToClose: true,
        }
      );
    },
    updateField(field, id, value) {
      ApiService.automationsApi
        .updateField(field, { id: id, value: value })
        .then(() => {
          this.$notify.info({
            title: "Automation status has been updated",
            message: "Updated!",
          });
          this.getAutomations();
        });
    },
  },
  mounted() {
    this.getAutomations();
  },
};
</script>
<style>
.smallFont {
  font-size: 11px;
}
</style>
